<template>
    <div id="app" v-animate-m="{name:'fadeIn',delay:'0.3s'}">
        <router-view />
    </div>
</template>
<script>
    import { initDynamicRoutes } from '@/router'
    export default {
        created() {
            initDynamicRoutes()
        }
    }
</script>
<style>
</style>